import { AUTH_PATHS } from "./auth";
import { COMMON_PATHS } from "./common/routes.common";
import { STANDALONE_PATHS } from "./common/standalone-paths";

import { MS_EVENT_PATHS } from "./my-space/routes.events";
import { MS_ASSETS_PATHS } from "./my-space/routes.asset";
import { MS_SETTINGS_PATHS } from "./my-space/routes.settings";
import { MS_DOCUMENTS_PATHS } from "./my-space/routes.documents";
import { MS_OFFBOARDING_PATHS } from "./my-space/routes.offboarding";
import { MS_PERFORMANCE_PATHS } from "./my-space/routes.performance";
import { MS_TIME_ATTENDANCE_PATHS } from "./my-space/routes.time-attendance";
import { MS_COMPANY_POLICIES_PATHS } from "./my-space/routes.company-policies";
import { MS_GUIDES_PATHS } from "./my-space/routes.guides";
import { MS_LEAVES_MANAGEMENT_PATHS } from "./my-space/routes.leave-management";

import { COMPANY_POLICIES_PATHS, COMPANY_POLICIES_CATEGORY_PATHS } from "./company/routes.company-policies-settings";
import { COMPANY_ASSETS_PATHS } from "./company/routes.asset";
import { COMPANY_EVENT_PATHS } from "./company/routes.events";
import { COMPANY_TEAMS_PATHS } from "./company/routes.teams";
import { COMPANY_PROJECTS_PATHS } from "./company/routes.projects";
import { COMPANY_SETTINGS_PATHS } from "./company/routes.settings";
import { COMPANY_WORKFLOWS_PATHS } from "./company/routes.workflow";
import { COMPANY_DOCUMENTS_PATHS } from "./company/routes.documents";
import { COMPANY_EMPLOYEES_PATHS } from "./company/routes.employees";
import { COMPANY_SUBSCRIPTION_PATHS } from "./company/routes.subscription";
import { COMPANY_ANNOUNCEMENTS_PATHS } from "./company/routes.announcement";
import { COMPANY_NOTIFICATIONS_PATHS } from "./company/routes.notifications";
import { COMPANY_PERFORMANCE_PATHS } from "./company/routes.performance";
import { COMPANY_HELP_SUPPORT_PATHS } from "./company/routes.help-and-support";
import { COMPANY_GUIDES_PATHS } from "./company/routes.guides";
import { COMPANY_TIME_ATTENDANCE_PATHS } from "./company/routes.time-attendance";
import { COMPANY_LEAVES_MANAGEMENT_PATHS } from "./company/routes.leave-management";
import { COMPANY_OFFBOARDING_PATHS } from "./company/routes.offboarding";
import { COMPANY_DATA_TRANSFER_PATHS } from "./company/routes.data-transfer";
import { COMPANY_ONBOARDING_PATHS } from "./company/routes.onboarding";
import { COMPANY_SETUP_PATHS } from "./company/routes.company-setup";

export const PATHS = Object.freeze({
  AUTH_PATHS,
  COMMON_PATHS,
  STANDALONE_PATHS,
  MY_SPACE: {
    MS_EVENT_PATHS,
    MS_ASSETS_PATHS,
    MS_SETTINGS_PATHS,
    MS_DOCUMENTS_PATHS,
    MS_OFFBOARDING_PATHS,
    MS_TIME_ATTENDANCE_PATHS,
    MS_COMPANY_POLICIES_PATHS,
    MS_GUIDES_PATHS,
    MS_LEAVES_MANAGEMENT_PATHS,
    MS_PERFORMANCE_PATHS,
  },
  COMPANY: {
    COMPANY_EVENT_PATHS,
    COMPANY_TEAMS_PATHS,
    COMPANY_ASSETS_PATHS,
    COMPANY_SETTINGS_PATHS,
    COMPANY_POLICIES_PATHS,
    COMPANY_WORKFLOWS_PATHS,
    COMPANY_EMPLOYEES_PATHS,
    COMPANY_PROJECTS_PATHS,
    COMPANY_DOCUMENTS_PATHS,
    COMPANY_SUBSCRIPTION_PATHS,
    COMPANY_PERFORMANCE_PATHS,
    COMPANY_HELP_SUPPORT_PATHS,
    COMPANY_GUIDES_PATHS,
    COMPANY_ANNOUNCEMENTS_PATHS,
    COMPANY_NOTIFICATIONS_PATHS,
    COMPANY_TIME_ATTENDANCE_PATHS,
    COMPANY_LEAVES_MANAGEMENT_PATHS,
    COMPANY_OFFBOARDING_PATHS,
    COMPANY_ONBOARDING_PATHS,
    COMPANY_SETUP_PATHS,
    COMPANY_POLICIES_CATEGORY_PATHS,
    COMPANY_DATA_TRANSFER_PATHS,
  },
});
